<template>
  <div class="flex items-center bg-red gap-2 my-[20px]">
    <div class="grow bg-gray-300 ml-4 lg:ml-8 h-[1px]"></div>
    <div
      class="border border-slate-200 border-opacity-50 shadow-md bg-[#fefefe] text-[10px] text-gray-500 rounded px-2 py-1 first-letter:uppercase font-medium"
    >
      {{ timestamp }}
    </div>
    <div class="grow bg-gray-300 mr-4 lg:mr-8 h-[1px]"></div>
  </div>
</template>
<script setup>
const props = defineProps({
  timestamp: {
    type: String,
    default: "",
  },
});
</script>
